import { WarehouseMapperParameter, WarehouseFactory } from "@/v2/models/warehouses.js";
import workingHourMixin from "@/v2/mixins/warehouse-working-hours.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import httpMixin from "@/v2/mixins/http.js";
import { timeToDate } from "@/v2/utils/date.js";

export default {
    mixins: [mapperMixin, httpMixin, workingHourMixin],
    computed: {
        warehouseUrl: {
            get() {
                return window.bo.warehouseUrl;
            },
        },
    },
    methods: {
        _warehouseMapper(warehouse) {
            return {
                id: warehouse.id,
                name: warehouse.name,
                post_title: warehouse.post_title,
                post_name: warehouse.post_name,
                code: warehouse.code,
                location_code: warehouse.location_code,
                location_type: warehouse.location_type,
                show_at_checkout: warehouse.show_at_checkout,
                working_hour_from: timeToDate(warehouse.working_hour_from),
                working_hour_to: timeToDate(warehouse.working_hour_to),
                working_hours: warehouse.working_hours,
                latitude: Number.parseFloat(warehouse.latitude),
                longitude: Number.parseFloat(warehouse.longitude),
                address: warehouse.address,
                address2: warehouse.address2,
                phone_number: warehouse.phone_number,
                email: warehouse.email,
                country: warehouse.country,
                state: warehouse.state,
                city: warehouse.city,
                zip_code: warehouse.zip_code,
                full_address: warehouse.full_address,
                vacation: warehouse.vacation,
                delay_in_hour: warehouse.delay_in_hour,
                note: warehouse.note,
                company_id: warehouse.company_id,
                company_name: warehouse.company_name,
                created_at: warehouse.created_at ? new Date(warehouse.created_at) : null,
                updated_at: warehouse.updated_at ? new Date(warehouse.updated_at) : null,
                deleted_at: warehouse.deleted_at ? new Date(warehouse.deleted_at) : null,
            };
        },

        parseWarehouse(warehouse) {
            return WarehouseFactory.construct(this.createMapperParameter(new WarehouseMapperParameter()), warehouse);
        },

        parseWarehouses(warehouses) {
            let parsedWarehouses = [];

            warehouses.forEach((warehouseData) => {
                const warehouse = this.parseWarehouse(warehouseData);
                parsedWarehouses.push(warehouse);
            });

            return parsedWarehouses;
        },

        getWarehouse(id, payload, success, failure) {
            return this.getData(
                this.warehouseUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parseWarehouse(response.data));
                },
                failure
            );
        },

        getWarehouses(payload, success, failure) {
            return this.getData(
                this.warehouseUrl,
                payload,
                (response) => {
                    success(this.parseWarehouses(response.data.data), response.data.meta);
                },
                failure
            );
        },

        createWarehouse(payload, success, failure) {
            return this.postData(
                this.warehouseUrl,
                payload,
                (response) => {
                    success(this.parseWarehouse(response.data));
                },
                failure
            );
        },

        updateWarehouse(id, payload, success, failure) {
            return this.putData(
                `${this.warehouseUrl}/${id}`,
                payload,
                (response) => {
                    success(this.parseWarehouse(response.data));
                },
                failure
            );
        },

        createOrUpdateWarehouse(id = null, payload, success, failure) {
            if (id == null) {
                return this.createWarehouse(payload, success, failure);
            } else {
                return this.updateWarehouse(id, payload, success, failure);
            }
        },

        deleteWarehouse(id, payload, success, failure) {
            return this.deleteData(
                `${this.warehouseUrl}/${id}`,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        deleteWarehouses(payload, success, failure) {
            return this.postBulkData(
                this.warehouseUrl,
                null,
                null,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        refreshWarehouse(id, warehouses, success, failure) {
            this.getWarehouse(
                id,
                this.warehouseUrl,
                null,
                (warehouse) => {
                    warehouses[id] = warehouse;
                    if (success) success(warehouse);
                },
                failure
            );
        },

        createCustomerLocation(payload, success, failure) {
            return this.postData(
                this.warehouseUrl,
                payload,
                (response) => {
                    success(response);
                },
                failure
            );
        },

        updateCustomerLocation(id, payload, success, failure) {
            return this.putData(
                `${this.warehouseUrl}/${id}`,
                payload,
                (response) => {
                    success(this.parseWarehouse(response.data));
                },
                failure
            );
        },

        createOrUpdateCustomerLocation(id = null, payload, success, failure) {
            if (id == null) {
                return this.createCustomerLocation(payload, success, failure);
            } else {
                return this.updateCustomerLocation(id, payload, success, failure);
            }
        },
    },
};
